<template>
    <div>
        <div style="padding: 10px;">
            <Form :model="formData" :label-width="120" style="height: 400px;padding: 5px;">
                <!--  <FormItem label="续费规则">
                会员有效期到期前15天为续费期，开启续费功能
            </FormItem> -->
                <!--             <FormItem label="账号说明">
                <span v-if="userData.myvippackage.length>0">您的账号：{{userData.userId}},当前会员包为：{{userData.myvippackage[0].title}},剩余有效天数：{{userData.myvippackage[0].remainingday}}天，有效期至：{{userData.myvippackage[0].expirationDate}}</span>
                <br />
                <span v-if="vipData.length>0">您已购买的升级包有：
                    <span v-for="item in vipData">{{item.funcname}}（数量：{{item.alreadybought}}，时长：{{vipOrderDays}}天）、</span>
                </span>
                <span v-else>您没有购买会员升级包</span>
            </FormItem> -->
                <FormItem label="可续费账号等级">
                    <tag color="success" size="large">{{formData?formData.name:''}}</tag>
                </FormItem>
                <FormItem label="续费时长">
                    <!--  <RadioGroup style="width: 390px;" v-model="formData.orderYears" @on-change="renewalTimeChange">
                    <Radio v-for="item in yearsData" :label="item.value">{{item.title}}</Radio>
                </RadioGroup>
                <span style="width: 150px;font-size: 12px;text-decoration:line-through;color:gray">原价：<span>{{productOriginalTotal}} 元</span></span>
                <span style="width: 150px;padding-left: 25px;">折后价：<span style="color: #ed4014;font-size:16px;">{{productNewPrice}} 元</span></span> -->
                    <div style="display: inline-block;width: 500px;">
                        <Row style="background:white;">
                            <Col v-for="item in productDiscount" :span="productDiscount.length===3?'7':productDiscount.length===2?'11':productDiscount.length===1?'24':'24'" :key="item.discountcode" offset="1">
                            <div :class="item.selected?'optionscard-select':'optionscard'" @click="cardSelect(item.discountcode)">
                                <div style="font-size:16px;font-weight: bold;color:#17233d;text-align: center;">{{item.salenumber}}年</div>
                                <div style="font-size:12px;color:#ed4014;text-align: center;">{{item.discountname}}</div>
                                <div style="height:1px;line-height: 1px;background-color:#dcdee2;margin:5px 0px;"></div>
                                <div style="font-size:14px;color:#ed4014;text-align: center;">
                                    <span style="font-size: 14px;">{{item.discountdesc}}</span>
                                </div>
                                <Icon color="#19be6b" size="16" class="select-icon" type="md-checkmark-circle" :style="{display:item.selected?'block':'none'}" />
                            </div>
                            </Col>
                        </Row>
                    </div>
                </FormItem>
                <Divider v-if="this.rowData&&this.rowData.productcode==='000001'?false:true" orientation="right">优惠信息</Divider>
                <!-- 优惠信息 -->
                <div>
                    <!--  会员优惠 -->
                    <!--  <div style="width: 500px;margin-left:auto;text-align: left;">
                    <Card :bordered="false" dis-hover>
                        <CellGroup>
                            <Cell v-for="item in productDiscount" :title="item.discountdesc" :key="item.salenumber">
                                <Icon v-if="item.selected" type="md-checkmark-circle" color="#19be6b" size="22" slot="extra" />
                                <span v-else slot="extra">未满足</span>
                            </Cell>
                        </CellGroup>
                    </Card>
                </div> -->
                    <div style="text-align:right;padding-right: 30px;height: 120px;">
                        <Coupon ref="mycoupon" @on-check="onCouponChecked" :isCouponShow="this.rowData&&this.rowData.productcode==='000001'?false:true" />
                    </div>
                </div>
                <!--     <div style="width: 50%;float:right;display: block;text-align: right;padding-right: 50px;">
                <Checkbox v-model="confirmPromocode" @on-change="confirmCode">确认优惠码和运营商编码</Checkbox>
            </div> -->
            </Form>
            <!-- 支付信息 -->
            <Divider orientation="right">支付信息</Divider>
            <div style="color:red;font-size: 18px;text-align: right;margin-right: 30px;">
                <!-- <span v-if="productOriginalTotal!==productNewPrice" style="text-decoration: line-through;color:#c5c8ce;font-size: 14px;padding-right: 20px;">原价:{{productOriginalTotal}}元</span>  -->
                <span>实际支付:{{productNewPrice}}元</span>
            </div>
            <div class="pay-change" style="text-align: right;margin-right: 20px;margin-top:10px;">
                <span>选择支付方式：</span>
                <RadioGroup v-model="payChange">
                    <Radio label="微信" border>
                        <i class="iconfont" style="color: #19c105;">&#xe650;</i>
                        <span style="color: #19c105;">微信</span>
                    </Radio>
                    <!-- <Radio label="支付宝" border>
                    <i class="iconfont" style="color: #00aaee;">&#xe618;</i>
                    <span style="color: #00aaee;">支付宝</span>
                </Radio> -->
                </RadioGroup>
            </div>
            <div class="invoiceContent">
                <span>发票信息：</span>
                <span v-if="invoiceType===1">普通发票</span>
                <span v-else-if="invoiceType===2">增值税专用发票</span>
                <span style="padding-left:5px;">{{invoiceHeaderName}}</span>
                <Button type="text" style="box-shadow:none;text-decoration:underline;color:#19be6b;" @click="showInvoice">修改</Button>
            </div>
            <Modal v-model="modalInvoice" width="700" :styles="{top: '15px'}" :mask-closable="false">
                <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                    <Icon type="ios-information-circle"></Icon>
                    <span>修改发票信息</span>
                </p>
                <div>
                    <Invoice ref='myInvoice' :isModal="true" />
                </div>
                <div slot="footer">
                    <Button type="text" size="large" @click="cancelInvoice">取消</Button>
                    <Button type="primary" size="large" @click="getInvoiceInfo">确定</Button>
                </div>
            </Modal>
            <QR ref="QRPayModal" @paySuccess="payComplete" @showAgreement="showPackageAgreement" />
            <Agreement ref="product_agreement" :isConfirm="true" @onAccept="onAgreementAccept" />
        </div>
        <!--   <div v-else style="padding: 10px;">团购用户不能续费账号等级</div> -->
    </div>
</template>
<script>
import moment from 'moment'
import coupon from './coupon.vue'
import invoice from "./myinvoice.vue"
import qrModal from './qrpay.vue'
import ProductAgreement from './product_agreement.vue'
import { mapGetters } from 'vuex'
import ConstJson from '../../api/common/constjson'
import store from "../../store/"
let constJ = new ConstJson()
export default {
    data() {
        return {
            copydata: '',
            memberLevelChkInfo: null,
            couponWarning: {
                rltdesc: '',
                iswarning: false
            },
            rowData: {},
            memberpkg: {
                endtime: '',
                name: '',
                orderid: '',
                productcode: '',
                productname: '',
                starttime: '',
            },
            currentDiscountData: null,
            currentPurchaseData: null,
            promocode: {
                couponcode: '',
                agentcode: '',
            },
            newprice: 0, //折后价
            oriprice: 0, //原价
            productDiscount: [],
            sonheadertype: 1,
            myInvoiceHeader: {
                bankaccount: "",
                bankname: "",
                headercode: "",
                headername: "个人",
                headertype: 1,
                invoiceTotal: 0,
                mobilenumber: "",
                officeaddress: "",
                postaddress: '',
                postemail: '',
                postmobile: '',
            },
            invoiceHeaderName: '个人',
            invoiceType: 1,
            modalInvoice: false,
            actualamount: 0,
            orderamount: 0,
            vipDiscount: [],
            vipOrderDays: 0,
            agreementChecked: true,
            couponValue: '',
            payChange: '微信',
            modalRenewalPay: false,
            data1: [],
            data2: [],
            packages: [], //['一键上传', '云擎下载', '分屏权限', '文件仓库'],
            couponItems: [],
            coupon: null,
            yearsOffItems: [{
                id: '9001',
                title: '全国版种子用户会员购满二年享9.5折优惠',
                discount: 0.95,
                isCheck: false,
            }, {
                id: '9002',
                title: '全国版种子用户会员购满三年享9折优惠',
                discount: 0.9,
                isCheck: false,
            }],
            yearsItem: {
                id: '9000',
                title: '无优惠',
                discount: 1,
                isCheck: false,
            }, //所有择的按年数优惠项
            packagesTotal: 0,
            value1: 0,
            value2: 0,
            vipPackages: [],
            shopList: [{
                orderYears: 1,
                desc: '',
                name: '',
            }],
            yearsData: [{
                    id: '30001',
                    title: '一年',
                    value: 1,
                    desc: '原价'
                },
                // {
                //     id: '30002',
                //     title: '二年',
                //     value: 2,
                //     desc: '优惠',
                // }, {
                //     id: '30003',
                //     title: '三年',
                //     value: 3,
                //     desc: '优惠',
                // }
            ],

        }
    },
    created() {
        // console.log('pay created....')
        // this.loadDefaultPackages()

        //this.formData=this.shopList[0]
        //this.show()
    },
    components: {
        'Coupon': coupon,
        "Invoice": invoice,
        'Agreement': ProductAgreement,
        'QR': qrModal,
    },
    computed: {
        ...mapGetters(['sta']),
        formData: function() {
            return this.shopList[0]
        },
        userData: function() {
            //console.log(store.state.user.myvippackage)
            return store.state.user
        },
        vipData: function() {
            let vdata = null
            if (this.userData.myextentionpackage.length === 0) {
                return []
            }
            //vdata = this.vipPackages
            vdata = this.userData.myextentionpackage.funcs; //this.vipPackages
            return vdata
        },
        // productName:function(){
        //     let name=''
        //     if(this.formData){
        //         //name=this.formData.desc+'('+this.formData.
        //     }
        //     return name
        // },
        // countDate() {
        //     return function(t1, t2) {
        //         let st = moment(t1).format("YYYY-MM-DD")
        //         let et = moment(t2).format("YYYY-MM-DD")
        //         let result = st + ' 至 ' + et

        //         return result
        //     }
        // },
        //会员包原价
        productOriginalTotal: function() {
            let p = this.oriprice //this.formData.price * this.formData.orderYears * 365
            return p
        },
        productNewPrice: function() {
            let p = this.newprice
            return p
        },

    },

    methods: {
        cardSelect(id) {
            console.log('cardSelect======>')
            console.log(id)
            this.productDiscount.forEach(function(item) {
                item.selected = false
            })
            const findelement = this.productDiscount.find(element => element.discountcode === id)
            findelement.selected = true
            let _index = this.productDiscount.findIndex(element => element.discountcode === id)
            this.$set(this.productDiscount, _index, findelement)
            console.log(findelement)
            this.newprice = findelement.newprice
            this.oriprice = findelement.oriprice
            this.currentDiscountData = findelement

            //拷贝切换到的原始价格
            let _copy = {
                oriprice: this.newprice
            }
            this.copydata = JSON.stringify(_copy)

            //切换账号等级年限并按checkbox计算优惠
            if (this.memberLevelChkInfo && this.memberLevelChkInfo.isChecked) {
                this.$refs.mycoupon.countPromocode(this.productNewPrice, this.showCouponPrice)
            }
            //console.log(this.cardOptions)

        },
        showCouponPrice(value) {
            this.newprice = value.item.amount
            this.oriprice = value.item.oriamount
            console.log(value)
        },
        onCouponChecked(chkinfo) {
            this.memberLevelChkInfo = chkinfo
            if (chkinfo.isChecked) {
                this.$refs.mycoupon.countPromocode(this.newprice, this.showCouponPrice)
            } else {
                this.$refs.mycoupon.clean()
                //还原到原始价格
                let _copy = JSON.parse(this.copydata)
                this.newprice = _copy.oriprice
                //this.loadDefaultPackages(this.rowData)
            }
        },
        showPackageAgreement() {
            this.$refs.product_agreement.show()
        },
        onAgreementAccept() {
            console.log("onAgreementAccept======>")
        },
        payComplete() {
            console.log('支付完成===>')
            this.$emit('payComplete')
        },
        cancelInvoice() {
            this.modalInvoice = false
        },
        getInvoiceInfo() {
            console.log("this.productNewPrice:" + this.productNewPrice)
            this.$refs.myInvoice.$refs.formData.validate((valid) => {
                if (valid) {
                    if (this.$refs.myInvoice.formData.headertype == 1) {
                        this.$refs.myInvoice.formData.headercode = ''
                        this.$refs.myInvoice.formData.officeaddress = ''
                        this.$refs.myInvoice.formData.mobilenumber = ''
                        this.$refs.myInvoice.formData.bankname = ''
                        this.$refs.myInvoice.formData.bankaccount = ''
                        // this.$refs.myInvoice.formData.postaddress = ''
                        // this.$refs.myInvoice.formData.postemail = ''
                        // this.$refs.myInvoice.formData.postmobile = ''
                    }
                    this.sonheadertype = Number(this.$refs.myInvoice.formData.headertype)
                    console.log(this.sonheadertype);
                    this.$refs.myInvoice.remData = JSON.parse(JSON.stringify(this.$refs.myInvoice.formData))
                    this.$refs.myInvoice.remheadertype = this.$refs.myInvoice.formData.headertype
                    let _invoiceType = this.$refs.myInvoice.invoicetype
                    let invoiceHeader = { ...this.$refs.myInvoice.formData }
                    this.invoiceHeaderName = this.$refs.myInvoice.formData.headertype == 1 ? '个人' : '单位'
                    this.invoiceType = Number(_invoiceType)
                    this.myInvoiceHeader = invoiceHeader
                    this.myInvoiceHeader.headertype = Number(invoiceHeader.headertype)
                    this.modalInvoice = false
                    console.log(this.invoiceType, invoiceHeader, this.invoiceHeaderName)
                } else {
                    this.$Message.error('请填写必填项！');
                    return
                }
            })

        },
        // getInvoiceInfo() {
        //     this.$refs.myInvoice.$refs.formData.validate((valid) => {
        //         if (valid) {
        //             let _invoiceType = this.$refs.myInvoice.invoicetype
        //             let invoiceHeader = { ...this.$refs.myInvoice.formData }
        //             this.invoiceHeaderName = this.$refs.myInvoice.formData.headername
        //             this.invoiceType = Number(_invoiceType)
        //             this.myInvoiceHeader = invoiceHeader
        //             this.myInvoiceHeader.headertype = Number(invoiceHeader.headertype)
        //             this.modalInvoice = false
        //             console.log(this.invoiceType, invoiceHeader, this.invoiceHeaderName)
        //         } else {
        //             this.$Message.error('请填写必填项!');
        //             return
        //         }
        //     })

        // },
        // getInvoiceInfo() {
        //     let _invoiceType = this.$refs.myInvoice.invoicetype
        //     let invoiceHeader = { ...this.$refs.myInvoice.formData }
        //     this.invoiceHeaderName = this.$refs.myInvoice.formData.headername
        //     this.invoiceType = Number(_invoiceType)
        //     this.myInvoiceHeader = invoiceHeader
        //     this.myInvoiceHeader.headertype = Number(invoiceHeader.headertype)
        //     this.modalInvoice = false
        //     console.log(this.invoiceType, invoiceHeader, this.invoiceHeaderName)
        // },
        showInvoice() {
            console.log('显示发票===>')
            this.modalInvoice = true
            this.$refs.myInvoice.invoiceTotal = this.productNewPrice
            //this.$refs.myInvoice.invoicetype = '1'
            //this.$refs.myInvoice.getInvoice()
        },

        //下单前检查优惠码和运营商信息,可以强制下单
        checkOrder() {
            let r = this.$refs.mycoupon.getConfirmInfo()
            console.log(r)
            if (r.iswarning) {
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>' + r.rltdesc + '</p>',
                    cancelText: "返回",
                    okText: "下单",
                    onOk: () => {
                        this.renewOrder()
                        //     setTimeout(() => { 
                        //         this.renewOrder()
                        // }, 1000);

                    },
                    onCancel: () => {
                        return
                    }
                });
            } else {
                this.renewOrder()
            }
        },
        //续费下单
        renewOrder() {
            // console.log(this.$refs.mycoupon.getConfirmInfo())
            console.log(this.currentPurchaseData)
            let product = this.currentPurchaseData
            let discountData = this.currentDiscountData
            this.promocode.couponcode = this.$refs.mycoupon.formCustom.couponValue
            this.promocode.agentcode = this.$refs.mycoupon.formCustom.agencies
            //console.log(product, discountData)
            let _invoice = {
                invoicetype: this.invoiceType,
                invoiceheader: this.myInvoiceHeader
            }
            let poData = {
                product: product.productcode,
                discount: discountData.discountcode,
                paytype: 30,
                couponcode: this.promocode.couponcode,
                agentcode: this.promocode.agentcode,
                invoice: _invoice,

            }
            constJ.reqRenewOrder(poData).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    this.base64str = `data:image/png;base64,` + res.result.strdata
                    this.orderid = res.result.orderid
                    let finalprice = res.result.actualAmount
                    let da = {
                        base64str: this.base64str,
                        orderid: this.orderid,
                        payChange: this.payChange,
                        totalBill: finalprice, //this.productNewPrice
                    }
                    console.log('po============>')
                    console.log(da)
                    this.$refs.QRPayModal.show(da)
                    this.getOrderContract(this.orderid)
                } else {

                    this.$Message.warning('下单异常,请稍后重试')

                    // return
                }
            }).catch(err => {
                console.log(err)
                this.$Message.warning(err)
                // return
            })
        },
        //获取合同信息
        getOrderContract(orderid) {
            //獲取合同信息
            console.log('获取升级包合同orderid:' + orderid)
            constJ.reqGetOrderContract(orderid).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    //this.showQRAndCheckPayStatus()
                    this.$refs.product_agreement.createdata(res.item)
                }
            })
        },
        onRowChange(value) {
            console.log(this.packages)
            console.log(this.vipData)
            this.showPayDiscount()
        },
        showProductDiscount(code) {
            var that = this
            constJ.reqProductDiscountList(code).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    //定义直接购买的选项数据items
                    this.productDiscount = res.item
                    if (!this.productDiscount || this.productDiscount.length === 0) {
                        this.$Message.warning('无产品优惠信息!')
                        return
                    }
                    this.productDiscount[0].selected = true

                    // this.productDiscount.forEach(function(item) {
                    //     if (item.discountcode === '000001') {
                    //         item.selected = true
                    //     } else {
                    //         item.selected = false
                    //     }
                    // })

                    // let p = this.productDiscount.find(p => p.discountcode === '000001')


                    this.currentDiscountData = this.productDiscount[0]
                    this.newprice = this.currentDiscountData.newprice
                    this.oriprice = this.currentDiscountData.oriprice

                    //this.modalPurchase = true

                    //拷贝原始价格
                    let _copy = {
                        oriprice: this.newprice
                    }
                    this.copydata = JSON.stringify(_copy)

                    //读取发票信息
                    this.$refs.myInvoice.getInvoice()
                    //this.$refs.myInvoice.invoiceTotal=this.productNewPrice


                    //获取发票信息
                    // var that = this
                    // this.$refs.myInvoice.getInvoice().then(function(resp) {
                    //     console.log('续费读取发票信息完成...')
                    //     that.getInvoiceInfo()
                    // })

                    // var _that = this
                    // this.$refs.myInvoice.getInvoice().then(function(resp) {
                    //     console.log(resp)
                    //     console.log('读取发票信息完成...')
                    //     if (resp.rltcode === 1 && resp.rtncode === 1) {
                    //         _that.getInvoiceInfo()
                    //     } else {
                    //         //设置初次默认
                    //         _that.$refs.myInvoice.formData.headertype = '1'
                    //         _that.$refs.myInvoice.formData.headername = '个人'
                    //     }

                    // })





                }
            })
        },
        popAgreement(value) {
            this.$emit('agreement', value)
            console.log(this.agreementChecked)
        },
        payFinished() {
            this.$Message.success('您的账号续费成功')
            this.modalRenewalPay = false
        },
        closePayModal() {
            this.modalRenewalPay = false
        },
        showPayModal() {
            this.modalRenewalPay = true
        },
        loadDefaultPackages(row) {
            var that = this
            console.log('product_renew.loadDefaultPackages-----')
            console.log(row)
            this.rowData = row

            // let max=0
            // max=store.state.user.myvippackage.length-1
            // let _productId = store.state.user.myvippackage[max].productcode
            // let _productOrderId = store.state.user.myvippackage[max].orderid
            // let st= store.state.user.myvippackage[max].starttime
            // let et= store.state.user.myvippackage[max].endtime
            // let myproducts = store.state.user.myproducts
            //let renewProduct = myproducts.find(p => p.code = _productId)

            let _productId = row.productcode
            let _productOrderId = row.orderid
            let st = row.starttime
            let et = row.endtime

            let st_format = moment(st).format("YYYY.MM.DD")
            let et_format = moment(et).format("YYYY.MM.DD")
            let renewProduct = row
            renewProduct.orderYears = 1
            renewProduct.name = renewProduct.productname + '(' + st_format + ' - ' + et_format + ')'
            this.currentPurchaseData = renewProduct
            console.log(this.currentPurchaseData)
            this.shopList = []
            this.shopList.push(renewProduct)
            this.showProductDiscount(_productId)
            //清空优惠券信息
            this.$refs.mycoupon.clean()
            //console.log(renewProduct)
            //console.log(this.userData)
            //this.showPayDiscount()

        },
        popClose() {
            //传送到购买升级包页面时，关闭当前modal
            console.log('ffffffffffff')
            this.$emit('closeModal')
            //console.log(this)
        },
        renewalTimeChange(value) {
            console.log(this.vipData)
        },
        yearsAutoDiscount() {
            let defaultCoupon = {
                id: '9000',
                title: '无优惠',
                discount: 1,
                isCheck: false,
            }
            this.yearsOffItems.forEach(function(item) {
                item.isCheck = false
            })
            //let ar = this.table_data.filter(p => p.class === 0)
            if (this.formData.orderYears === 1) {
                this.yearsItem = defaultCoupon
            }
            if (this.formData.orderYears === 2) {
                this.yearsItem = this.yearsOffItems.find(p => p.id === '9001')
                this.yearsItem.isCheck = true
            }
            if (this.formData.orderYears === 3) {
                this.yearsItem = this.yearsOffItems.find(p => p.id === '9002')
                this.yearsItem.isCheck = true
            }

        },
    },
}
</script>
<style scoped>
@font-face {
    font-family: 'iconfont';
    /* project id 1804652 */
    src: url('//at.alicdn.com/t/font_1804652_306rskp3iol.eot');
    src: url('//at.alicdn.com/t/font_1804652_306rskp3iol.eot?#iefix') format('embedded-opentype'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.woff2') format('woff2'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.woff') format('woff'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.ttf') format('truetype'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.svg#iconfont') format('svg');
}

.iconfont {
    font-size: 16px;
    font-family: 'iconfont';
    margin-right: 10px;
}

.user-herder-pay-name {
    font-size: 14px;
    padding-left: 53px;
}

.user-herder-pay-time {
    font-weight: 500;
    font-size: 14px;
    float: right;
    padding-right: 80px;
}

.payAmount {
    font-size: 20px;
    color: #f55d54;
    height: 30px;
}


.labelTxt {
    width: 100%;
    height: 32px;
    line-height: 32px;
    padding: 0 7px;
    text-align: left;
    outline: 0;
    -moz-appearance: textfield;
    color: #666;
}

.labelTxt2 {
    height: 32px;
    line-height: 32px;
    padding: 0 7px;
    text-align: left;
    outline: 0;
    -moz-appearance: textfield;
    color: #666;
}


/*选择账号等级*/
.optionscard {
    display: grid;
    border: 1px solid #dcdee2;
    padding: 20px;
    cursor: Pointer;

}

.optionscard-select {
    background-color: #FFF1F3;
    display: grid;
    border: 1px solid #ed4014;
    padding: 20px;
    cursor: Pointer;
}

.select-icon {
    position: absolute;
    bottom: 5px;
    left: 80%;
}



/*pay modal*/
.vipmodal/deep/.ivu-modal-body {
    padding: 0px;
}

.vipmodal/deep/.ivu-modal-header {
    background-color: #FEE7AA;
}


h2 {
    height: 75px;
    line-height: 50px;
    text-align: center;
}

.scentitle {
    font-size: 10px;
    color: #ccc;
    line-height: 50px;
    text-align: center;
}

.card-title-desc {
    font-size: 12px;
    color: #808695;
    height: 20px;
    line-height: 20px;
    margin-top: 5px;
}



.agreement-content {
    margin-top: 10px;
    margin-right: 20px;
    font-size: 10px;
    text-align: right;
}

.agreement-user {
    font-size: 10px;
    color: #4386f5;
    cursor: pointer;
}


/*发票信息*/
.invoiceContent {
    margin-top: 10px;
    text-align: right;
    margin-right: 12px;

    span {
        padding-left: 10px;
    }
}
</style>